module.exports = __webpack_public_path__ + "img/keno_logo_15.701ea273.png";